const iframeRegex = /\[iframe (https[^\]]+)\]/g

export default (description, prevDescription) => description?.length
  ? description.replace(iframeRegex, "<iframe src='$1' style='border:none'></iframe>")
  : prevDescription
